const api = {
  baseURL: "https://ukqb9c93bb.execute-api.eu-central-1.amazonaws.com/prod",
};

const config = {
  api,
};

export default config;
